// Shared geometry for the POS floor-plan grid, used by both the PMS table
// editor and the POS tables view so the grid and the tables stay in proportion.

/** Size of a single grid cell, in pixels. */
export const CELL_SIZE = 44

/** Gap between a table and its grid cell edges, in pixels. */
export const GAP = 8
